import { gql } from "@apollo/client";

/**
 * What a member — real or described — can attend in a window.
 *
 * Pass `email` to load a real member (the reply's `member` carries her real
 * settings, which the screen uses to fill the dropdowns in), or pass the
 * attributes directly to describe one.
 */
export const MEMBER_EXPERIENCE = gql`
  query adminMemberExperience(
    $from: Date
    $to: Date
    $email: String
    $kind: String
    $isVerified: Boolean
    $planSlug: String
    $speakingLevelScore: Float
    $attendedEvents: Int
    $joinedAt: Date
  ) {
    adminMemberExperience(
      from: $from
      to: $to
      email: $email
      kind: $kind
      isVerified: $isVerified
      planSlug: $planSlug
      speakingLevelScore: $speakingLevelScore
      attendedEvents: $attendedEvents
      joinedAt: $joinedAt
    ) {
      member {
        userId
        name
        email
        isReal
        kind
        planSlug
        subscriptionTier
        isVerified
        isStaff
        attendedEvents
        advancedUnlocked
        joinedAt
      }
      events {
        eventId
        canAttend
        verdict
        joinReason
        lockReason
      }
      total
      canAttend
      locked
      blocked
    }
  }
`;
